// extracted by mini-css-extract-plugin
export default {"list":"style_list__T65FJ","title":"style_title__v9lmt"};